import { useParticipationStore } from "@/stores/useParticipationStore";

export function useCheckLink() {
  const participationStore = useParticipationStore();

  async function verifyLink(to) {

    console.log('im here :>> ');
    const specialCode = to.params.code || to.query.code || null;
    console.log('specialCode :>> ', specialCode);
    if (!specialCode) {
      return {
        success: false,
        message: "missing_code"
      };
    }

    if (
      participationStore.link &&
      participationStore.participation &&
      participationStore.link === specialCode
    ) {
      return {
        success: true,
        message: "cached_valid",
        participation: participationStore.participation
      };
    }

    participationStore.link = specialCode;

    try {
      const response = await participationStore.checkLink();

      if (response?.data?.success) {
        return {
          success: true,
          message: "fresh_valid",
          participation: participationStore.participation
        };
      } else {
        return { success: false, message: "invalid_code" };
      }
    } catch (err) {
      return { success: false, message: "invalid_code" };
    }
  }

  return { verifyLink };
}
